export function isNullOrWhiteSpace(str: string | null): boolean {
    return (str === null || str.match(/^\s*$/)) ? true : false;
}

export function isUndefinedNullOrWhiteSpace(str: string | null | undefined): boolean {
    return (str == null || str.match(/^\s*$/)) ? true : false;
}